// 合并所有reducer 并且返回
import { combineReducers } from "redux"
import { reducer as MapReducer } from "./map/index"
import { reducer as AnalysisReducer } from "../routes/Analysis/store"
// import { map } from "./map"
// import { dataSource } from "./dataSource"
// import { trajectory } from "./trajectory"
// import { baseMap } from "./baseMap"
// import { datePicker } from "./datePicker"

export default combineReducers({
  map: MapReducer,
  analysis: AnalysisReducer
  // map,
  // dataSource,
  // trajectory,
  // baseMap,
  // datePicker,
})
